'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  elevation: _propTypes2.default.number,
  theme: _propTypes2.default.object
};
var defaultProps = {
  elevation: 1
};

var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme,
      elevation = _ref.elevation,
      noShadow = _ref.noShadow;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  var _theme$reactackle$com = theme.reactackle.components.card.card,
      borderRadius = _theme$reactackle$com.borderRadius,
      backgroundColor = _theme$reactackle$com.backgroundColor;
  return (0, _styledComponents.css)(['border-radius:', ';background-color:', ';display:flex;align-items:stretch;', ';&,&*,*::after,*::before{font-family:', ';box-sizing:border-box;}'], (0, _reactackleCore.getValueString)(borderRadius), backgroundColor, !noShadow && (0, _reactackleCore.boxShadow)(elevation - 1), fontFamily);
};

var CardStyled = exports.CardStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CardStyled'
})(['width:100%;', ';'], baseProps);

CardStyled.propTypes = propTypes;
CardStyled.defaultProps = defaultProps;
CardStyled.displayName = 'CardStyled';